import { render, staticRenderFns } from "./WxNeilingGoods.vue?vue&type=template&id=611f31c7&scoped=true&"
import script from "./WxNeilingGoods.vue?vue&type=script&lang=js&"
export * from "./WxNeilingGoods.vue?vue&type=script&lang=js&"
import style0 from "./WxNeilingGoods.vue?vue&type=style&index=0&id=611f31c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611f31c7",
  null
  
)

export default component.exports